import { useCallback, useState } from 'react';
import { DIALOG_ANIMATION_DURATION } from './useDialogWithPayload';

export interface UseDialogWithUidsOutput {
  show(uids: string[]): void;
  close(): void;
  visible: boolean;
  uids: string[];
}

export function useDialogWithUids(initialUid: string[] = []): UseDialogWithUidsOutput {
  const [uids, setUids] = useState<string[]>(initialUid);
  const [visible, setVisible] = useState<boolean>(!!initialUid.length);
  const show = useCallback((uids: string[]) => {
    setUids(uids);
    setVisible(true);
  }, []);

  const close = useCallback(() => {
    setVisible(false);
    setTimeout(() => {
      setUids([]);
    }, DIALOG_ANIMATION_DURATION);
  }, []);

  return {
    show,
    close,
    visible,
    uids
  };
}
